module.exports = facilityDefinition;